import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(private translate: TranslateService) { }

  alertTopRight(msg:string){
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    })

    Toast.fire({
      icon: 'success',
      iconColor: '#6F7479',
      background: '#DCD7D6',
      title: `<p class="text-principal text-2xl font-normal">${msg}</p>`
    })
  }


  alertToastCenter(msg:string){
    const Toast = Swal.mixin({
      toast: true,
      position: 'center',
      showConfirmButton: false,
      timer: 1000,
      timerProgressBar: true,
    })

    Toast.fire({
      icon: 'success',
      iconColor: '#6F7479',
      background: '#DCD7D6',
      padding: '1rem 2rem',
      title: `<p class="text-principal text-2xl font-normal">${msg}</p>`
    })
  }


  alertError(msg: string){
    Swal.fire({
      text: `${msg}`,
      icon: 'error'
    })
  }



   alertErrorConfirm(msg: string){
    return Swal.fire({
      text: `${msg}`,
      icon: 'error',
      showCancelButton: true,
      cancelButtonColor: '#00000096',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Contact Me'
    })
  }



  confirmAddress(provincia, ciudad,street,destinatario){
    return  Swal.fire({
      title: this.translate.instant('alerts.confirmarDireccion'),
      html: `${provincia} - ${ciudad} <br> ${street} <br> ${destinatario}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#ffcad4',
      cancelButtonColor: '#00000096',
      cancelButtonText:this.translate.instant('buttons.cancelar'),
      confirmButtonText: this.translate.instant('buttons.aceptar')
    })
  }

   confirmCancel(){
    return  Swal.fire({
      title: 'Are you sure you want to cancel your subscription?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#E52922FF',
      cancelButtonColor: '#00000096',
      confirmButtonText: 'Yes, cancel it',
      cancelButtonText: 'No, go back'
    })
  }

  loseInfo(){
    return Swal.fire({
      text: this.translate.instant('alerts.textLose'),
      titleText: this.translate.instant('alerts.titleLose'),
      icon:'warning',
      showCancelButton: true,
      confirmButtonColor: 'succes',
      cancelButtonColor: '#00000096',
      cancelButtonText:this.translate.instant('buttons.cancelar'),
      confirmButtonText: this.translate.instant('buttons.aceptar')
    })
  }

}
